<template>
  <div
    class=""
    :class="{ required: error}"
  >
    <label for="">{{ label }}</label>
    <select
      v-model="inputValue"
      :name="inputName"
      @change="currentValue"
    >
      <option value="0">
        0
      </option>
      <option value="1">
        1
      </option>
      <option value="2">
        2
      </option>
      <option value="3">
        3
      </option>
      <option value="4">
        4
      </option>
      <option value="5">
        5
      </option>
      <option value="6">
        6
      </option>
      <option value="7">
        7
      </option>
      <option value="8">
        8
      </option>
      <option value="9">
        9
      </option>
      <option value="10">
        10
      </option>
    </select>
  </div>
</template>
<script>
export default {
    name: 'HlmSelect',
    props: {
        value: String,
        inputRequired: {
            type: Boolean,
            default: false
        },
        label: String,
        inputName: String,
    },
    data() {
        return {
            inputValue: 0,
            error: '',
        }
    },
    computed: {
        isRequired() {
            return this.inputRequired ? 'required' : '';
        }
    },
    methods: {
        currentValue: function(e) {
            console.log(this.inputName);

            this.$emit('payment', this.inputName, this.inputValue * 75)
            this.$emit('finished', this.inputName, this.inputValue)
        },
        requiredCheck: function(e) {
            if (this.inputRequired && this.inputValue == '') {
                return this.error = 'required';
            } else {
                return this.error = '';
            }

            // console.log(this.inputRequired);
            e.preventDefault();
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* --- hlm registration forms --- */

* {
    box-sizing: border-box;
}

button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
    padding: .6em 1em .4em;
    border: 1px solid;
    border-color: #ccc #ccc #bbb;
    border-radius: 3px;
    background: #e6e6e6;
    color: rgba(0, 0, 0, 0.8);
    line-height: 1;
    font-size: 12px;
    font-size: 0.75rem;
}

button:hover,
input[type="button"]:hover,
input[type="reset"]:hover,
input[type="submit"]:hover {
    border-color: #ccc #bbb #aaa;
}

button:active,
button:focus,
input[type="button"]:active,
input[type="button"]:focus,
input[type="reset"]:active,
input[type="reset"]:focus,
input[type="submit"]:active,
input[type="submit"]:focus {
    border-color: #aaa #bbb #bbb;
}

a {
    text-decoration: none;
}

input[type="text"],
input[type="email"],
input[type="url"],
input[type="password"],
input[type="range"],
input[type="date"],
input[type="month"],
input[type="week"],
input[type="time"],
input[type="datetime"],
input[type="datetime-local"],
input[type="color"],
textarea {
    border: 2px solid #ededed !important;
    border-radius: 0px;
    color: #555;
    margin: 0 0 5px 0;
    font-size: 14px !important;
    padding: 10px !important;
    font-family: "Open Sans", sans-serif;
}



input[type="text"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="number"]:focus,
input[type="range"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="week"]:focus,
input[type="time"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="color"]:focus,
textarea:focus {
    background-color: #ededed !important;
}

select {
    margin: 0;
    display: block;
    width: 100px;
    padding: .5rem .75rem !important;
    font-size: 14px;
    line-height: 1.25;
    color: #464a4c;
    background-color: #fff;
    background-image: none;
    background-clip: padding-box;
    border: 2px solid #ededed !important;
    border-radius: 100px;
    box-shadow: none !important;
    touch-action: manipulation;
}

select:not([size]):not([multiple]) {
    height: calc(2.25rem + 2px);
}

label {
    display: inline-block;
    margin: 5px 0 5px 3px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    line-height: 24px;
    text-align: left;
}

input {
    display: block;
    margin: 0px 0;
    padding-right: 10px;
    padding-left: 10px;
    width: 100%;
    border-color: #fff;
    background-color: #fff;
    /*background-color: #eaeaea;*/
    color: #000;
    letter-spacing: 1px;
    font-weight: 200;
    font-size: 12px;
    font-family: Lovelo, sans-serif;
    line-height: 30px;
}


label {
    width: calc(100% - 20px);
}


.required .error {
    display: block;
}

.error {
    font-weight: 400;
    font-size: 12px;
    font-family: Lovelo, sans-serif;
    line-height: 12px;
    margin: 5px 0 5px 11px;
    padding: 0px;
    color: #ec1c24;
    display: block;
    text-align: left;
    display: none;
}

.error input {
    border-color: #ec1c24;
}
</style>